import { IHttpClient } from '@/core/services/http'
import { ResetPasswordDto } from '../types/dtos/reset-password.dto'

export function createResetPasswordUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (credentials: ResetPasswordDto) {
    await httpClient
      .version('v1')
      .post('/website/buyer/reset-password', credentials)
  }
}
